export function supportsAirwallexApplePay(currency, browser = window) {
  if (String(currency || '').toUpperCase() !== 'SGD' || !browser.isSecureContext) return false;
  try {
    return !!(browser.ApplePaySession
      && browser.ApplePaySession.supportsVersion(4)
      && browser.ApplePaySession.canMakePayments());
  } catch (error) {
    return false;
  }
}

export function applePayOptions(intentId, clientSecret, amount, currency, label) {
  if (String(currency || '').toUpperCase() !== 'SGD'
    || !intentId || !clientSecret || !Number.isFinite(Number(amount)) || Number(amount) <= 0) {
    throw new Error('Apple Pay requires a valid SGD payment.');
  }
  return {
    intent_id: intentId,
    client_secret: clientSecret,
    amount: { value: Number(amount), currency: 'SGD' },
    countryCode: 'SG',
    totalPriceLabel: label,
    buttonType: 'pay',
    buttonColor: 'black',
    // Capture belongs to the existing backend approval/settlement flow.
    autoCapture: false,
  };
}
